import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Table, Loader, Segment} from 'semantic-ui-react';
import _ from 'lodash';
import {Actions} from '../../../../../common/actions';

class BackOrdersModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
    };
  }

  fetchData() {
    const {code} = this.props;
    this.props.fetchBackOrdersDetail(code);
    this.setState({'modalWasOpen': true});
  }

  renderTable(list) {
    if (!list || list.length === 0) {
      return <Segment textAlign='center'>No hay datos disponibles</Segment>;
    }
    return (
      <Table striped className='toyota-grid'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              Concesionario
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Agencia</Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>Usuario</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>{this.renderItems(list)}</Table.Body>
      </Table>
    );
  }

  renderItems(list) {
    return list.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.quantity}</Table.Cell>
          <Table.Cell textAlign='center'>{element.dealer}</Table.Cell>
          <Table.Cell textAlign='center'>{element.agency}</Table.Cell>
          <Table.Cell textAlign='center'>{element.user}</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {quantity, loading, backOrdersDetail} = this.props;
    const {modalWasOpen} = this.state;
    const existDataAfterCallApi = modalWasOpen && backOrdersDetail;

    if (
      (existDataAfterCallApi && _.sumBy(backOrdersDetail, 'quantity') === 0) ||
      !quantity
    ) {
      return <div>0</div>;
    }
    return (
      <Modal
        size='small'
        onOpen={() => this.fetchData()}
        trigger={
          <div className='link'>
            {existDataAfterCallApi ?
              _.sumBy(backOrdersDetail, 'quantity') :
              quantity}
          </div>
        }
        closeIcon
      >
        <Modal.Header>
          Back Orders
          <span className='quantity-container'>
            {existDataAfterCallApi ?
              _.sumBy(backOrdersDetail, 'quantity') :
              quantity}
          </span>
        </Modal.Header>

        <Modal.Content scrolling>
          <Modal.Description>
            {loading && <Loader active inline='centered' />}
            {!loading && this.renderTable(backOrdersDetail)}
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partModals.loadingBackOrdersDetail,
    'backOrdersDetail': state.partModals.backOrdersDetail,
  };
};

const {fetchBackOrdersDetail} = Actions;

export default connect(mapStateToProps, {
  fetchBackOrdersDetail,
})(BackOrdersModal);
